import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

// Define a type for the slice state
interface AccountState {
    mnemonic?: string | null
    publicKey?: string | null
    rawMnemonic?: string
}

// Define the initial state using that type
const initialState: AccountState = {
    mnemonic: localStorage.getItem('dc_mnemonic'),
    publicKey: localStorage.getItem('dc_publicKey'),
}

export const accountSlice = createSlice({
    name: 'account',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setMnemonic: (state, action: PayloadAction<string>) => {
            localStorage.setItem('dc_mnemonic', action.payload)
            state.mnemonic = action.payload
        },
        setPublicKey: (state, action: PayloadAction<string>) => {
            localStorage.setItem('dc_publicKey', action.payload)
            state.publicKey = action.payload
        },
        removeAccount: (state) => {
            localStorage.removeItem('dc_mnemonic')
            localStorage.removeItem('dc_publicKey')
            state.mnemonic = null
            state.publicKey = null
            state.rawMnemonic = undefined
        },
        setRawMnemonic: (state, action: PayloadAction<string>) => {
            state.rawMnemonic = action.payload
        },
    },
})

export const { setMnemonic, removeAccount, setPublicKey, setRawMnemonic } =
    accountSlice.actions

export const selectMnemonic = (state: RootState) => state.account.mnemonic
export const selectRawMnemonic = (state: RootState) => state.account.rawMnemonic
export const selectPublicKey = (state: RootState) => state.account.publicKey
export default accountSlice.reducer
